import {
  Body1,
  Radio,
  RadioGroup,
  RadioGroupOnChangeData,
  RadioGroupProps,
  mergeClasses,
} from "@fluentui/react-components";
import { ICartItemOptionGroup } from "../Schema";
import React from "react";
import { useStyles } from "./Styles";

type SingleSelectOptionsProps = {
  optionGroup: ICartItemOptionGroup;
  setValue: (value: ICartItemOptionGroup) => void;
} & Omit<RadioGroupProps, "onChange">;

export const SingleSelectOptionGroup = React.forwardRef<HTMLDivElement, SingleSelectOptionsProps>(
  (props: SingleSelectOptionsProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const styles = useStyles();
    const { optionGroup, setValue, ...rest } = props;

    const updateSelected = React.useCallback(
      (optionId: string) => ({
        ...optionGroup,
        options: optionGroup.options.map((option) => ({
          ...option,
          isSelected: option.id === optionId,
        })),
      }),
      [optionGroup],
    );
    return (
      <RadioGroup
        disabled={props.disabled}
        data-testid="singleSelectOptionGroup"
        ref={ref}
        {...rest}
        onChange={(e, data: RadioGroupOnChangeData) => {
          const value = updateSelected(data.value);
          setValue(value);
        }}
      >
        {optionGroup.options?.map((option) => (
          <Radio
            data-testid="singleSelectOption"
            checked={option.isSelected}
            key={option.id}
            className={
              option.isSelected ? mergeClasses(styles.checked, styles.option) : styles.option
            }
            label={
              <Body1 className={option.isSelected ? styles.text : ""}>
                {option.name}
                {option.price.amount > 0 &&
                  `(+ ${option.price.currencyUnit}${option.price.amount.toFixed(2)})`}
              </Body1>
            }
            value={option.id}
          />
        ))}
      </RadioGroup>
    );
  },
);

SingleSelectOptionGroup.displayName = "SingleSelectOptionGroup";
